var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridIcon = function SvgGridIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm16 2h-4v4h4V2Zm0 6h-4v4h4V8Zm-6-2V2H8v4h4ZM8 8h4v4H8V8ZM6 6V2H2v4h4ZM2 8h4v4H2V8Zm6 6h4v4H8v-4Zm10 4h-4v-4h4v4ZM2 14h4v4H2v-4Z",
    fill: "#455A64"
  })));
};
export default SvgGridIcon;